<script setup lang="ts">
/**
 * The template's row title, editable in place at the top of the editor header — where it was
 * rendered read-only until RND-53. Rules in `template-title.hook.ts`.
 */
import type { InputPrimaryEvent } from '@shared/ui/fields'

import { InputPrimary } from '@shared/ui/fields'

import { useTemplateTitle } from '../../../model/assessments/template-title.hook'

defineOptions({
  name: 'TemplateTitleInput',
})

const {
  refTitle,
  refMode,
  setTitle,
} = useTemplateTitle()
</script>

<template>
  <div class="template-title-input">
    <!-- No VISIBLE label, like the grade select it shares the header with: a label line would push
         the field out of alignment with the buttons beside it, and the intro card below already
         names this "the template title above". `aria-label` names it for a screen reader instead,
         since the placeholder disappears the moment the field holds a title. -->
    <InputPrimary
      id="assessment-template-row-title"
      name="templateTitle"
      aria-label="Template title"
      :value="refTitle"
      :mode="refMode"
      placeholder="Template title"
      @input="(event: InputPrimaryEvent) => setTitle(String(event.value ?? ''))"
    />
  </div>
</template>

<style scoped lang="scss" src="./TemplateTitleInput.scss" />
